export default {
    namespaced: true,
    state: {
        categories: [],
        category: null,
        icons: [
            {
                icon: 'cata-icon'
            },
            {
                icon: 'catb-icon'
            },
            {
                icon: 'catc-icon'
            },
            {
                icon: 'catd-icon'
            },
            {
                icon: 'cate-icon'
            },
            {
                icon: 'catf-icon'
            },
            {
                icon: 'catg-icon'
            },
            {
                icon: 'cath-icon'
            }
        ]
    },
    mutations: {
        setCategories: (state, categories) => {
            state.categories = categories;
        },

        setCategory: (state, category) => {
            state.category = category;
        },
    },
    actions: {
        getCategories(context) {
            return this.$axios.get('/categories', {
                    params: {
                        type: 'vignette'
                    }
                })
                .then(response => {
                    if(response.data.categories) {
                        context.commit('setCategories', response.data.categories);
                    }
                    
                    return response;
                });
        },

        getCategory(context, category_id) {
            return this.$axios.get('/category/' + category_id, {
                    params: {
                        type: 'vignette'
                    }
                })
                .then(response => {
                    if(response.data.category) {
                        context.commit('setCategory', response.data.category);
                    }

                    return response;
                });
        },
    },
    getters: {
        getCategories: (state) => {
            return state.categories;
        },

        getCategory: (state) => {
            return state.category;
        },
    }
}
